// extracted by mini-css-extract-plugin
export default {"comment_style":"SessionFeedbackDrawer_comment_style__TXLyM","comment_date_style":"SessionFeedbackDrawer_comment_date_style__vWTEt"};